export const addEllipsisPointsAboveCharactersLimit = (message, limit) => {
  if (typeof message !== 'string') throw new Error('Only string accepted');

  const cutText = (text) => [...text].splice(0, limit).join('');

  if (message.length > limit) return `${cutText(message)}...`;

  return message;
};
